import { ERevenueAgencyFakeType } from '../types'

export const REVENUE_AGENCY_FAKE_TYPE_COLORS_MAP: Record<ERevenueAgencyFakeType, string> = {
	[ERevenueAgencyFakeType.None]: 'bg-grey',
	[ERevenueAgencyFakeType.AccountFB]: 'bg-danger',
	[ERevenueAgencyFakeType.Creo]: 'bg-success',
	[ERevenueAgencyFakeType.Installs]: 'bg-warning',
	[ERevenueAgencyFakeType.Slices]: 'bg-info', //TODO: check the bg-color-className
}